import "./Releases.module.css";
import Navigation from "@/reusable_sections/Header";
import NewMusic from "./sections/NewMusic";
import Albumslideshowcarousel from "./sections/Albumslideshowcarousel";
import Footer from "@/reusable_sections/Footer";
export default function ReleasesPage() {
  return <div>
      <Navigation />
      <NewMusic />
      <Albumslideshowcarousel />
      <Footer />
    </div>;
}